import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'

const MONTHS = [
  'Januar',
  'Februar',
  'März',
  'April',
  'Mai',
  'Juni',
  'Juli',
  'August',
  'September',
  'Oktober',
  'November',
  'Dezember'
]

const pad = (value = '', len = 0, str = ' ') => {
  return `${
    Array(...Array(Math.max(len - value.length, 0))).map(() => str).join('')
  }${value}`
}

export default class MonthSelect extends Component {

  static propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    end: PropTypes.bool,
    id: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    required: PropTypes.bool,
    start: PropTypes.bool,
    value: PropTypes.string,
  }

  getMonth(dateStr) {
    const date = new Date(dateStr)
    return date.getMonth() + 1
  }

  @autobind
  handleChange(e) {
    e.stopPropagation()

    const { target: { value } } = e
    const { onChange, end, name } = this.props
    const now = new Date()
    let day = 1

    const month = new Date()
    month.setMonth(value - 1)
    month.setDate(1)

    if (end) {
      month.setMonth(month.getMonth() + 1)
      month.setDate(month.getDate() - 1)
      day = month.getDate()
    }

    const dateStr = `${
      now.getFullYear()}-${pad(`${value}`, 2, '0')}-${pad(`${day}`, 2, '0')
    }`

    if (onChange) {
      onChange({
        target: {
          name,
          value: dateStr
        }
      })
    }

  }

  render() {
    const {
      id,
      className,
      name,
      disabled,
      required,
      value,
      end
    } = this.props
    return (
      <select
        id={id}
        className={className}
        name={name}
        disabled={disabled}
        required={required}
        value={this.getMonth(value) || (end ? 12 : 1)}
        onChange={this.handleChange}
      >
        {MONTHS.map((month, i) => {
          return <option key={month} value={i + 1}>{month}</option>
        })}
      </select>
    )
  }

}



// WEBPACK FOOTER //
// ./src/shared/components/MonthSelect.js